import React from "react";

const PersonForm = () => {
  return <div></div>;
};

export default PersonForm;
